import { Component, OnInit, HostListener } from '@angular/core';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';

import { JhiLanguageHelper, StateStorageService } from '../../shared';
import { Angulartics2Piwik } from 'angulartics2/piwik';
import { NavigationService } from '../../shared/services/navigation.service';
import { ParametersService } from '../../shared/services/parameters.service';

@Component({
    selector: 'jhi-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class JhiMainComponent implements OnInit {

    showNavigationButton = false;
    // The navigation button on the main content area will not be visible on its pages
    routeExcluded: Array<string> = ['/authentication', '/reset/request', '/register/morale', '/register/particulier', '/'];

    constructor(
        private jhiLanguageHelper: JhiLanguageHelper,
        private router: Router,
        private stateStorageService: StateStorageService,
        private navigationService: NavigationService,
        private parametersService: ParametersService,
        // @ts-ignore
        private angulartics2Piwik: Angulartics2Piwik,
        // @ts-ignore (load the translation just by being requested)
        private jhiLanguageService: JhiLanguageService
    ) {
        this.angulartics2Piwik.startTracking();
    }

    ngOnInit() {
        this.parametersService.loadParameters();
        this.showNavigationButton = this.router && this.routeExcluded.indexOf(this.router.url) === -1;
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.jhiLanguageHelper.updateTitle();
                window.scrollTo(0, 0);
                this.showNavigationButton = this.routeExcluded.indexOf(event.url) === -1;
            }
            if (event instanceof RoutesRecognized) {
                this.stateStorageService.storeDestinationState(event.urlAfterRedirects);
            }
        });
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(_event) {
        this.navigationService.markAsGoingBack();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/main/main.component.ts